import { formModes, minDateValue, tripDestinations, customEventTypes } from '../../../constants.js';
import { checkReportForms, checkResultForms } from '../../helpers/CheckFunctions.js';
import { eventDispatcher } from '../../../eventDispatcher.js';

export default {
    updateFields(documentData, context) {
        const { formMode } = context;

        const nowDate = new Date();

        const reportForm = documentData.form.fields.find(f => f.name === 'reportForm');
        reportForm.minDate = minDateValue;
        reportForm.maxDate = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate());

        const attachmentsField = reportForm.fields.find(f => f.name === 'sx:attachments');
        attachmentsField.disabled = formMode === formModes.read;

        const documentDateField = reportForm.fields.find(f => f.name === 'sx:rpDocumentDate');
        documentDateField.maxValue = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate());

        const amountInCurrencyField = reportForm.fields.find(f => f.name === 'sx:rpAmountInCurrency');
        const currencyField = reportForm.fields.find(f => f.name === 'sx:rpCurrency');
        amountInCurrencyField.visible = currencyField.visible = documentData.properties['businessTrip']?.properties['sx:btBusinessTripDestination'] !== tripDestinations.ukraine;

        let sum = 0;
        if (documentData.properties['reportForm']?.length > 0) {
            documentData.properties['reportForm'].forEach(form => {
                const reportSum = form.properties['sx:rpAmountUAH']?.toString();
                if (reportSum) {
                    const reportSumValue = parseFloat(reportSum.replaceAll(' ', '').replace(',', '.'));
                    if (reportSumValue) {
                        sum += reportSumValue;
                    }
                }
            });
        }
        documentData.properties['sx:arSum'] = sum.toFixed(2).replace('.', ',');

        reportForm.multiple = checkReportForms(documentData).result;

        const resultForm = documentData.form.fields.find(f => f.name === 'resultForm');
        const attachmentsForm = documentData.form.fields.find(f => f.name === 'sx:attachments');
        const reportDescriptionField = documentData.form.fields.find(f => f.name === 'sx:btrReportDescription');
        if (!documentData.properties['sx:btrNeedReport']) {
            resultForm.minCount = 0;
            resultForm.visible = false;
            attachmentsForm.visible = false;
            reportDescriptionField.visible = false;
        }
    },

    checkInputPage(documentData) {
        let result = true;
        let errorElementName = '';
        let errorElementId = '';
        let nIndex = 0;

        if (!documentData.properties["assoc:sx:arEmployee_added"]) {
            result = false;
            errorElementName = "assoc:sx:arEmployee_added";
        }
        if (result) {
            const formCheckResult = checkReportForms(documentData);

            if (!formCheckResult.result) {
                result = false;
                errorElementName = formCheckResult.errorElementName;
                errorElementId = formCheckResult.errorElementId;

                eventDispatcher.invokeEvent(customEventTypes.onSubformError, {
                    subformName: 'reportForm',
                    index: formCheckResult.formIndex
                });
            }
            else {
                const resultFormCheckResult = checkResultForms(documentData);

                if (!resultFormCheckResult.result) {
                    result = false;
                    errorElementName = resultFormCheckResult.errorElementName;
                    errorElementId = resultFormCheckResult.errorElementId;

                    eventDispatcher.invokeEvent(customEventTypes.onSubformError, {
                        subformName: 'resultForm',
                        index: resultFormCheckResult.formIndex
                    });
                }
            }
        }

        return {
            result,
            errorElementName,
            errorElementId,
            nIndex
        };
    }
}